// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__zvVCj","contentWrap":"Hero_contentWrap__NpaC-","logo":"Hero_logo__zu6BM","link":"Hero_link__b5gqy"};